import type { useMousePosition } from '@shared/hooks/use-mouse-position'

interface CandidateNoteProps {
  mousePosition: ReturnType<typeof useMousePosition>['mousePosition']
}

export const CandidateNote = ({ mousePosition }: CandidateNoteProps) => {
  return (
    <div
      data-testid="candidate-node"
      style={{
        position: 'absolute',
        left: mousePosition.x - 60,
        top: mousePosition.y - 70,
        zIndex: 10000,
      }}
    >
      <div className="rounded-sm w-[200px] h-[100px] group relative p-3 border-2 border-dashed bg-bg2 border-st2">
        <div className="text-p-400 text-tertiary">Write your note...</div>
      </div>
    </div>
  )
}
